export default "__VITE_ASSET__Cb9FqUs4__"